module.exports = __webpack_public_path__ + "img/chat.68a260a6.svg";